import { createSelector } from 'reselect';
import {
  getCompaniesItems,
  getCompaniesIsFetching,
  getCompaniesIsLoaded,
} from './forexCompanies';

const getProducts = state => state.forexProducts;

export const getProductsIsFetching = createSelector(
  getProducts,
  products => products.isFetching
);

export const getProductsIsLoaded = createSelector(
  getProducts,
  products => products.isLoaded
);

export const getProductsIds = createSelector(
  getProducts,
  products => products.ids
);

export const getProductsEntities = createSelector(
  getProducts,
  products => products.entities
);

export const getProductsItems = createSelector(
  getProductsIds,
  getProductsEntities,
  (ids, entities) => ids.map(id => entities[id])
);

export const getItemsIsLoaded = createSelector(
  getCompaniesIsLoaded,
  getProductsIsLoaded,
  (isCompaniesLoaded, isProductsLoaded) => isCompaniesLoaded && isProductsLoaded
);

export const getItemsIsFetching = createSelector(
  getCompaniesIsFetching,
  getProductsIsFetching,
  (isCompaniesFetching, isProductsFetching) =>
    isCompaniesFetching || isProductsFetching
);

const divideLists = arr =>
  arr.reduce(
    ([arr1, arr2], elem) => {
      return elem.popular ? [[...arr1, elem], arr2] : [arr1, [...arr2, elem]];
    },
    [[], []]
  );

export const getProductsItemsWithCompaniesInfo = createSelector(
  getProductsItems,
  getCompaniesItems,
  (productsItems, companiesItems) => {
    const normalizedProducts = productsItems.map(product => {
      const productCompany =
        companiesItems.find(
          companyItem => companyItem.financeId === product.vendorId
        ) || {};

      return {
        id: product.id,
        vendorId: product.vendorId,
        productName: product.productName,
        companyId: productCompany.id,
        companySlug: productCompany.slug,
        companyName: productCompany.name,
        companyFinanceId: productCompany.financeId,
        companyLogo: productCompany.logo,
        order: productCompany.order,
        popular: productCompany.popular,
      };
    });
    const [hotList, standardList] = divideLists(normalizedProducts);
    return [hotList, standardList].map(arr =>
      arr
        .filter(product => !!product.companyId)
        .sort((productItem1, productItem2) => {
          if (productItem1.order && productItem2.order) {
            return productItem1.order - productItem2.order;
          }
          return 0;
        })
    );
  }
);

export const makeIsItemsLoaded = () => getItemsIsLoaded;

export const makeIsItemsFetching = () => getItemsIsFetching;

export const makeProductsItems = () => getProductsItems;

export const makeProductsItemsWithCompaniesInfo = () =>
  getProductsItemsWithCompaniesInfo;
